import { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Calling from './api/Calling';

import { ToastContainer } from 'react-toastify';
import { ClientToastContainer } from './components/Client/clientToast';
import Navbar1 from './components/Navbar/Navbar1';
import Navbar2 from './components/Navbar/Navbar2';
import Login from './admin/Login/Login';
import Page404 from './components/page/Page404';
import Logout from './admin/Login/Logout';
import Error from './admin/Login/Error';
import Home from './admin/Home';
import NewPw from './admin/Login/NewPw';
import ForgetPw from './admin/Login/ForgetPw';
import ForgetPwOtp from './admin/Login/ForgetPwOtp';
import LoginOtp from './admin/Login/LoginOtp';
import Profile from './admin/Profile/Profile';
import UIIntroScreen from './admin/UI/UIIntroScreen';
import Controller from './admin/Controller/Controller';
import ViewsDashbord from './admin/ViewsDashbord';
import BannerAds from './admin/Ads/BannerAds/BannerAds';
import NativeAds from './admin/Ads/NavtiveAds/NativeAds';
import FullScreenAds from './admin/Ads/FullScreenAds/FullScreenAds';
import OpenAds from './admin/Ads/OpenAds/OpenAds';
import RewardAds from './admin/Ads/RewardAds/RewardAds';
import InHouseAds from './admin/Ads/InHouseAds/InHouseAds';
import EditeInHouseAds from './admin/Ads/InHouseAds/EditeInHouseAds';
import AiModel from './admin/AiModel/AiModel';
import List from './admin/List/List';
import Category from './admin/category/Category';
import Policy from './admin/Policy/Policy';
import GuideVideo from './admin/Controller/GuideVideo';
import IosNativeAds from './admin/Ads/ios/IosNavtiveAds/IosNativeAds';
import IosFullScreenAds from './admin/Ads/ios/IosFullScreenAds/IosFullScreenAds';
import IosBannerAds from './admin/Ads/ios/IosBannerAds/IosBannerAds';
import IosOpenAds from './admin/Ads/ios/IosOpenAds/IosOpneAds';
import IosRewardAds from './admin/Ads/ios/IosRewardAds/IosRewardAds';
import Banner from './admin/Banner/Banner';
import Notification from './admin/Controller/Notification';
import INSPACTLOCK from './components/INSPACTLOCK';
import PP from './client/PP';
import ClientHome from './client/ClientHome';
import Story from './admin/Story/Story';
import ClientCategory from './client/ClientCategory';
import ClientProduct from './client/ClientProduct';
import AboutUs from './client/About';
import Terms from './client/Terms';
import Faq from './client/Faq';
import Contact from './client/Contact';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/Client/CookieConsent';
import ClientSearch from './client/ClientSearch';
import Suggestion from './admin/Controller/Suggestion';
import ClientSuggestion from './client/ClientSuggestion';
import AdsTxtEditor from './admin/Controller/AdsTxtEditor';
import Blog from './admin/Blog/Blog';
import BlogInfo from './admin/Blog/BlogInfo';
import ClientBlog from './client/ClientBlog';
import ClientBlogInfo from './client/ClientBlogInfo';
import Gateway from './client/Gateway';
import ClientBlogInfo1 from './client/ClientBlogInfo1';
// import IosWebAds from './admin/Ads/ios/IosWebAds/IosWebAds';


function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }

  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem('picpromptify_admin');
    navigate('/admin/panel/login');
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem('picpromptify_admin');

        if (!adminToken) {
          setIsAuthorized(false);
          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  return (
    <div className="flex roboto-regular bg-main-bg">
      <ToastContainer />
      <ClientToastContainer />
      <ScrollToTop />
      <INSPACTLOCK />
      {isAuthorized && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/Logout" element={<Logout onLogout={handleLogout} />} />
              <Route path='/profile' element={<Profile />} />

              {/* Native Ads */}
              <Route path='/manage/ads/nativeAds/add' element={<NativeAds />} />

              {/* FullScreenAds */}
              <Route path='/manage/ads/fullScreenAds/add' element={<FullScreenAds />} />

              {/* Banner Ads */}
              <Route path='/manage/ads/bannerAds/add' element={<BannerAds />} />

              {/* Open Ads */}
              <Route path='/manage/ads/openAds/add' element={<OpenAds />} />

              {/* Reward Ads */}
              <Route path='/manage/ads/rewardAds/add' element={<RewardAds />} />

              {/* InHouseAds */}
              <Route path='/manage/ads/inHouseAds/add' element={<InHouseAds />} />
              <Route path='/manage/ads/inHouseAds/edit/:id' element={<EditeInHouseAds />} />

              {/* Banner */}
              <Route path='/manage/banner' element={<Banner />} />

              {/* Views Dashbord */}
              <Route path='/views/dashboard/:id' element={<ViewsDashbord />} />

              {/* AI Model */}
              <Route path='/manage/aiModel' element={<AiModel />} />

              {/* List */}
              <Route path='/manage/list' element={<List />} />

              {/* Category */}
              <Route path='/manage/category' element={<Category />} />

              {/* UI UX */}
              <Route path='/manage/UI/introscreen' element={<UIIntroScreen />} />


              {/* Controller */}
              <Route path='/controller' element={<Controller />} />

              {/* Notification */}
              <Route path='/notification' element={<Notification />} />

              {/* Policy */}
              <Route path='/manage/policy' element={<Policy />} />

              {/* Guide Video */}
              <Route path='/guide/video' element={<GuideVideo />} />


              {/* Ios Ads */}
              {/* Native Ads */}
              <Route path='/manage/ads/ios/nativeAds/add' element={<IosNativeAds />} />

              {/* FullScreenAds */}
              <Route path='/manage/ads/ios/fullScreenAds/add' element={<IosFullScreenAds />} />

              {/* Banner Ads */}
              <Route path='/manage/ads/ios/bannerAds/add' element={<IosBannerAds />} />

              {/* Open Ads */}
              <Route path='/manage/ads/ios/openAds/add' element={<IosOpenAds />} />

              {/* Reward Ads */}
              <Route path='/manage/ads/ios/rewardAds/add' element={<IosRewardAds />} />

              {/* Web Ads */}
              {/* <Route path='/manage/ads/ios/webAds/add' element={<IosWebAds />} /> */}

              <Route path='/policy' element={<PP />} />

              {/* Story */}
              <Route path='/manage/story' element={<Story />} />

              {/* Suggestion */}
              <Route path='/manage/suggestion' element={<Suggestion />} />

              {/* Suggestion */}
              <Route path='/manage/ads/txt' element={<AdsTxtEditor />} />


              {/* UI UX */}
              <Route path='/manage/blog' element={<Blog />} />
              <Route path='/manage/blog/:id' element={<BlogInfo />} />

              <Route path="*" element={<Error />} />
            </>
          ) : (
            <>
              <Route path='/admin/panel/login' element={<Login />} />
              <Route path='/admin/panel/login/otp' element={<LoginOtp onLogin={handleLoginStatusChange} />} />
              <Route path='/admin/panel/forgetpw' element={<ForgetPw />} />
              <Route path='/admin/panel/forget/otp' element={<ForgetPwOtp />} />
              <Route path='/admin/panel/new/password' element={<NewPw />} />
              <Route path='/admin/panel/new/password' element={<NewPw />} />


              {/* Client */}
              <Route path='/' element={<ClientHome />} />
              <Route path='/category/:id' element={<ClientCategory />} />
              <Route path='/List/:id' element={<ClientProduct />} />
              <Route path='/privacy-policy' element={<PP />} />
              <Route path='/about' element={<AboutUs />} />
              <Route path='/terms' element={<Terms />} />
              <Route path='/faqs' element={<Faq />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/search' element={<ClientSearch />} />
              <Route path='/suggestion/send' element={<ClientSuggestion />} />
              <Route path='/blog' element={<ClientBlog />} />
              <Route path='/blog/:id' element={<ClientBlogInfo />} />
              <Route path='/gateway' element={<Gateway />} />
              <Route path='/blog/info/:id' element={<ClientBlogInfo1 />} />

              <Route path='*' element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
